
//Import Init function 
import initJS from './init';
// initJS();

//Import Barba seperately
import './functions/init-barba';


// import Swiper styles
import '../../../node_modules/swiper/swiper.scss';
// Import choices styles
import '../../../node_modules/choices.js/public/assets/styles/choices.css';

// Import Parent scss file here. This will compile to a css file in the dist folder
import '../../../../individual-restaurants/library/src/sass/style.scss';

// Import main scss file here. This will compile to a css file in the dist folder
import '../sass/style.scss';